import Popover, { positionBounded } from '@components/Popover/Popover';
import { ContentSection, TitleSection } from '@components/Popover/PopoverLayouts';

import styles from './CardHeader.module.scss';
import { SelectImageTypeContent } from './SelectImageType';
import type { ImageType, ImageUrls } from './types';

interface SelectImageTypePopoverProps {
  imgUrls?: ImageUrls;
  onClose: () => void;
  onSelect: (type: ImageType) => void;
  show: boolean | undefined;
  targetNode: HTMLElement | undefined;
}

export const SelectImageTypePopover: React.FC<React.PropsWithChildren<SelectImageTypePopoverProps>> = ({
  imgUrls,
  onClose,
  onSelect,
  show,
  targetNode,
}) => {
  return (
    <Popover
      positioner={positionBounded({ offsetX: 8, xPreference: 'right', alignY: 'cover' })}
      targetNode={targetNode}
      show={!!show}
      onClose={onClose}
      preventOutsideInteraction
      drawFocus={true}
    >
      <TitleSection text="Which image would you like to upload?" onClose={onClose} />

      <ContentSection>
        <div className={styles['next-image']}>
          <div className={styles['select-image-buttons']}>
            <SelectImageTypeContent canLock={false} imgUrls={imgUrls} onSelect={onSelect} />
          </div>
        </div>
      </ContentSection>
    </Popover>
  );
};
